import React from 'react';
import ICON_NAMES from './iconNames';

const IconTemplate = (props) => {
  const { children, width, height, disabled, className } = props;

  return (
    <svg
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        pointerEvents: disabled ? 'none' : 'all',
      }}
    >
      {children}
    </svg>
  );
};

const Icon = (props) => {
  const { name, fill, onEnter, onLeave } = props;

  switch (name) {
    case ICON_NAMES.bosch:
      return (
        <IconTemplate {...props} width={44} height={11}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.96674 7.05652C5.92783 7.69215 5.33143 7.90381 5.11945 7.90381H2.86644V6.07414H5.08147C5.19633 6.07414 5.96674 6.24783 5.96674 7.05652ZM8.5279 7.2685C8.5279 5.30374 7.02569 5.01519 7.02569 5.01519C7.02569 5.01519 8.10426 4.49536 8.10426 3.18583C8.10426 1.048 6.27459 0.412685 5.54278 0.412685H0.574219V9.84897H5.88954C6.87192 9.84897 8.5279 8.8476 8.5279 7.2685ZM5.63927 3.26271C5.63927 3.85943 5.08116 4.1679 4.86918 4.1679H2.86613V2.37683H4.69549C4.90747 2.37683 5.63927 2.5888 5.63927 3.26271ZM15.7112 5.13067C15.7112 6.49841 14.9408 7.82693 13.6312 7.82693C12.3024 7.82693 11.532 6.4981 11.532 5.13067C11.532 3.82114 12.3024 2.51161 13.6312 2.55021C14.9411 2.55021 15.7112 3.85943 15.7112 5.13067ZM18.0417 5.13067C18.0417 2.51161 16.2699 0.297202 13.6316 0.297202C10.9546 0.297202 9.16352 2.51192 9.16352 5.13067C9.20212 7.82693 10.9543 10.1185 13.6316 10.1185C16.2696 10.1185 18.0797 7.82693 18.0417 5.13067ZM26.1295 7.01793C26.1295 3.18552 20.93 4.80321 21.2382 3.01214C21.354 2.33823 22.0472 2.24173 22.6442 2.24173C23.6642 2.24173 24.3774 3.05074 24.3774 3.05074L25.7831 1.56782C24.7241 0.585753 23.9537 0.162109 22.4708 0.162109C20.5643 0.162109 18.8115 1.35585 18.8115 3.301C18.8115 6.03586 21.8352 6.03586 22.8948 6.36301C23.5301 6.53639 23.7035 6.70976 23.6645 7.13341C23.6645 7.59596 22.9331 8.0386 22.4322 8.0386C21.354 8.11548 20.7183 7.55705 19.9675 6.80595L18.5232 8.36606C19.8328 9.63699 20.9882 10.1185 22.4325 10.0799C24.3002 10.0223 26.1295 8.96277 26.1295 7.01793ZM34.9694 7.86584L33.0629 6.67148C33.0629 6.67148 32.2924 7.82693 31.4063 7.82693C30.0005 7.86584 29.2304 6.4595 29.2304 5.09238C29.2304 3.74425 29.943 2.55021 31.2721 2.55021C32.0425 2.55021 32.5816 3.01245 32.9281 3.64807L34.7574 2.45433C34.4493 1.9924 33.7368 0.3358 31.4063 0.258915C28.8837 0.201329 26.8806 2.55052 26.8806 5.09269C26.8806 7.82724 28.4983 9.98406 31.4834 9.98406C33.005 10.0223 34.199 9.05958 34.9694 7.86584ZM43.4236 9.84897V0.412374H41.0545V3.95561H38.1662V0.412374H35.7398V9.84866H38.1083V6.07414H41.0545V9.84897H43.4236Z"
            fill="white"
          />
        </IconTemplate>
      );
    case ICON_NAMES.tools:
      return (
        <IconTemplate {...props} width={29} height={29}>
          <path
            fill="#FFF"
            d="M21.2,24.4c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2l-5.3-5.3c-0.1-0.1-0.2-0.2-0.2-0.3  c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3l2.2-2.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.3-0.1,0.4-0.1  c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2l5.3,5.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.3-0.1,0.4  c0,0.1-0.1,0.2-0.2,0.3l-2.2,2.2c-0.1,0.1-0.2,0.2-0.3,0.2C21.4,24.4,21.3,24.4,21.2,24.4z M21.2,21.9l0.8-0.8l-3.9-3.9l-0.8,0.8  L21.2,21.9z M6.8,24.4c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.4-0.2l-2.2-2.2c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.1-0.1-0.3-0.1-0.4  c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3l5.6-5.6h2.2l0.9-0.9L8.2,9.6H6.7L3.5,6.5l3-3l3.2,3.2v1.5l4.3,4.3l3-3l-1.1-1.1  l1.5-1.5h-3l-0.7-0.7l3.7-3.7l0.7,0.7v3l1.5-1.5l3.7,3.7c0.3,0.3,0.5,0.6,0.7,1c0.2,0.4,0.2,0.8,0.2,1.2c0,0.4-0.1,0.8-0.2,1.2  c-0.2,0.4-0.4,0.7-0.7,1l-2.2-2.2L19.6,12l-1.1-1.1l-5.4,5.4v2.2l-5.6,5.6c-0.1,0.1-0.2,0.2-0.3,0.2C7.1,24.4,6.9,24.4,6.8,24.4z   M6.8,21.9l4.5-4.5v-0.8h-0.8L6,21.1L6.8,21.9z M6.8,21.9L6,21.1l0.4,0.4L6.8,21.9z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.extension:
      return (
        <IconTemplate {...props} width={29} height={29}>
          <path
            d="M16.3332 7.00033C16.3332 5.71166 17.3778 4.66699 18.6665 4.66699H20.9998C22.2885 4.66699 23.3332 5.71166 23.3332 7.00033V9.33366C23.3332 10.6223 22.2885 11.667 20.9998 11.667H18.6665C17.3778 11.667 16.3332 10.6223 16.3332 9.33366V7.00033Z"
            stroke="white"
            strokeWidth="1.5"
            style={{ fill: 'none' }}
          />
          <path
            d="M4.6665 18.667C4.6665 17.3783 5.71117 16.3337 6.99984 16.3337H9.33317C10.6218 16.3337 11.6665 17.3783 11.6665 18.667V21.0003C11.6665 22.289 10.6218 23.3337 9.33317 23.3337H6.99984C5.71117 23.3337 4.6665 22.289 4.6665 21.0003V18.667Z"
            stroke="white"
            strokeWidth="1.5"
            style={{ fill: 'none' }}
          />
          <path
            d="M4.6665 7.00033C4.6665 5.71166 5.71117 4.66699 6.99984 4.66699H9.33317C10.6218 4.66699 11.6665 5.71166 11.6665 7.00033V9.33366C11.6665 10.6223 10.6218 11.667 9.33317 11.667H6.99984C5.71117 11.667 4.6665 10.6223 4.6665 9.33366V7.00033Z"
            stroke="white"
            strokeWidth="1.5"
            style={{ fill: 'none' }}
          />
          <path
            d="M16.3332 18.667C16.3332 17.3783 17.3778 16.3337 18.6665 16.3337H20.9998C22.2885 16.3337 23.3332 17.3783 23.3332 18.667V21.0003C23.3332 22.289 22.2885 23.3337 20.9998 23.3337H18.6665C17.3778 23.3337 16.3332 22.289 16.3332 21.0003V18.667Z"
            stroke="white"
            strokeWidth="1.5"
            style={{ fill: 'none' }}
          />
        </IconTemplate>
      );
    case ICON_NAMES.history:
      return (
        <IconTemplate {...props} width={22} height={19}>
          <path
            fill="#0a2352"
            d="M11.524 5.278v5.278l4.452 2.66.807-1.352-3.688-2.206v-4.38zM12.57 0C7.365 0 3.143 4.254 3.143 9.5H0l4.075 4.106.074.148L8.38 9.5H5.238c0-4.085 3.28-7.389 7.333-7.389 4.055 0 7.334 3.304 7.334 7.389 0 4.085-3.28 7.389-7.334 7.389a7.247 7.247 0 0 1-5.175-2.175l-1.487 1.5A9.346 9.346 0 0 0 12.57 19C17.778 19 22 14.746 22 9.5S17.778 0 12.571 0z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.logOut:
      return (
        <IconTemplate {...props} width={20} height={18}>
          <path fill="#fff" d="M2 16h8v2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h8v2H2zm18-7l-5 5-1.41-1.42L16.17 10H6V8h10.17l-2.58-2.59L15 4z" />
        </IconTemplate>
      );
    case ICON_NAMES.logo:
      return (
        <IconTemplate {...props} width={40} height={40}>
          <path
            fill="#fff"
            d="M6.031 14.574a15.08 15.08 0 0 1 7.302-7.907v8H6zm20.38 18.505a14.483 14.483 0 0 1-8.658 1.353 14.474 14.474 0 0 1-7.8-3.858 14.514 14.514 0 0 1-4.541-10.099h8.192V30.63h5.498V0c-.827.081-1.647.143-2.466.28a19.757 19.757 0 0 0-6.682 2.402A20.237 20.237 0 0 0 0 19.154v1.793c.03.698.098 1.394.205 2.084a20.12 20.12 0 0 0 9.749 14.256A19.763 19.763 0 0 0 19.96 40h.202a19.751 19.751 0 0 0 9.886-2.713 20.116 20.116 0 0 0 9.749-14.253c.106-.692.173-1.388.202-2.087v-1.793a20.226 20.226 0 0 0-9.95-16.47A19.704 19.704 0 0 0 23.366.282C22.545.146 21.725.084 20.897 0v30.63h5.513V6.907h.014c.21.106.418.218.62.333a14.587 14.587 0 0 1 7.55 12.764 14.612 14.612 0 0 1-8.192 13.098z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.search:
      return (
        <IconTemplate {...props} width={22} height={22}>
          <path
            fill="#fff"
            d="M9.232 15.623A6.383 6.383 0 0 1 2.84 9.232 6.383 6.383 0 0 1 9.23 2.84a6.383 6.383 0 0 1 6.392 6.39 6.383 6.383 0 0 1-6.391 6.392zm8.521 0h-1.122l-.397-.383a9.19 9.19 0 0 0 2.23-6.008A9.231 9.231 0 0 0 9.232 0 9.231 9.231 0 0 0 0 9.232a9.231 9.231 0 0 0 9.232 9.232 9.19 9.19 0 0 0 6.008-2.23l.383.397v1.122L19.883 22 22 19.884z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.user:
      return (
        <IconTemplate {...props} width={20} height={20}>
          <path
            fill="#fff"
            d="M10,2.5c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S8.3,2.5,10,2.5 M10,13.5c3.4,0,7,1.8,7,2.6v1.4H3
	          v-1.4C3,15.3,6.6,13.5,10,13.5 M10,0.5c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S12.8,0.5,10,0.5z M10,11.5c-3,0-9,1.5-9,4.6v3.4h18
	          v-3.4C19,13,13,11.5,10,11.5z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.close:
      return (
        <IconTemplate {...props} width={10} height={10}>
          <path fill={fill} d="M10 8.59L8.59 10 5 6.41 1.41 10 0 8.59 3.59 5 0 1.41 1.41 0 5 3.59 8.59 0 10 1.41 6.41 5 10 8.59z" />
        </IconTemplate>
      );
    case ICON_NAMES.info:
      return (
        <IconTemplate {...props} width={22} height={22}>
          {onEnter && (
            <path
              fill="#1d8eff"
              d="M11,0c6.1,0,11,4.9,11,11s-4.9,11-11,11S0,17.1,0,11S4.9,0,11,0z M12,10h-2v6h2V10z M12,6
            h-2v2h2V6z"
            />
          )}
          {onLeave && (
            <path
              fill="#1d8eff"
              d="M10,6h2v2h-2V6z M10,10h2v6h-2V10z M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z
            M11,20c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S16,20,11,20z"
            />
          )}
        </IconTemplate>
      );

    case ICON_NAMES.selected:
      return (
        <IconTemplate {...props} width={16} height={16}>
          <path fill="#0a2352" d="M6 13.42l-5-5 1.41-1.41L6 10.59 13.59 3 15 4.42l-9 9z" />
        </IconTemplate>
      );
    case ICON_NAMES.list:
      return (
        <IconTemplate {...props} width={18} height={10}>
          <path fill={fill} d="M2 4H0v2h2zM0 0v2h2V0zm2 8H0v2h2zm16 0H4v2h14zm0-4H4v2h14zm0-4H4v2h14z" />
        </IconTemplate>
      );
    case ICON_NAMES.card:
      return (
        <IconTemplate {...props} width={18} height={18}>
          <path fill={fill} d="M16 12h-4v4h4zm2-2v8h-8v-8zm-2-8h-4v4h4zm2-2v8h-8V0zM6 12H2v4h4zm2-2v8H0v-8zM6 2H2v4h4zm2-2v8H0V0z" />
        </IconTemplate>
      );
    case ICON_NAMES.auto_search:
      return (
        <IconTemplate fill={fill} {...props} width={26} height={22}>
          <path
            fill="#fff"
            d="M4 13.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm15 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 4.5h-4.884l-1.45-2.42c-.305-.508-.792-.808-1.31-.808H9.708c-.534 0-1.034.318-1.335.85L7.029 18H2v-5.726C2 10.469 3.409 9 5.14 9h15.72C22.59 9 24 10.448 24 12.228zM9.18 2h7.643c1.283 0 2.475.873 3.033 2.217L21 7H5l1.144-2.778C6.705 2.872 7.896 2 9.18 2zm15.335 6.344l-2.796-5.24C20.688 1.19 18.658 0 16.421 0H9.576C7.342 0 5.313 1.188 4.278 3.106l-2.775 5.19a1.583 1.583 0 0 0-.074.162A5.501 5.501 0 0 0 0 12.147v8.32C0 21.314.661 22 1.477 22h1.906c.816 0 1.477-.686 1.477-1.533V19.7h16.28v.767c0 .847.66 1.533 1.477 1.533h1.906c.816 0 1.477-.686 1.477-1.533v-8.355c0-1.39-.516-2.693-1.46-3.714-.008-.018-.016-.037-.025-.054z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.liquid:
      return (
        <IconTemplate {...props} width={23} height={24}>
          <path
            fill="#fff"
            d="M16.259 20a4.327 4.327 0 0 0 3.09-1.325 4.54 4.54 0 0 0 1.272-3.176C20.62 13.014 16.259 8 16.259 8s-4.362 5.014-4.362 7.5a4.54 4.54 0 0 0 1.27 3.175 4.326 4.326 0 0 0 3.092 1.324zm-3.263 2c-1.992-1.094-3.156-3.843-3.156-6.285 0-2.011 1.607-5.102 3.16-7.16V6.841L11.306 6H7.132L2 8.996V22zM8 2v2h3V2zm15 13.36c0 3.352-3.242 6.69-6.504 6.69a5.694 5.694 0 0 1-1.556-.241v.91a1.29 1.29 0 0 1-.363.904c-.233.24-.55.376-.882.377H1.245a1.237 1.237 0 0 1-.882-.377A1.29 1.29 0 0 1 0 22.72V8c0-.387.173-.753.467-.996L6.361 4V1.168a1.29 1.29 0 0 1 .363-.903C6.957.025 7.139 0 7.47 0h3.735c.332.001.649.137.882.377.234.24.364.565.363.903v2.03l2.126 1.385c.233.24.364.566.364.905v1.041c.272-.33 1.203-1.17 1.556-1.17.354 0 6.504 6.9 6.504 9.889zM7.25 9c.432.023.767.47.75 1v6c.017.529-.318.977-.75 1h-1.5c-.432-.023-.767-.471-.75-1v-6c-.017-.529.318-.977.75-1z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.car_battery:
      return (
        <IconTemplate {...props} width={24} height={22}>
          <path
            fill="#fff"
            d="M20 2h-3v2h-2V.97c-.016-.518.378-.952.88-.97h5.24c.502.018.896.452.88.97V4h-2zm-5 3.03V4H9v1.03c.016.518-.378.953-.88.97h7.76c-.502-.017-.896-.452-.88-.97zm7 0c.016.518-.378.953-.88.97H22v14H2V6h.879c-.502-.018-.895-.452-.879-.97V4H.74a.7.7 0 0 0-.524.244.888.888 0 0 0-.216.59v16.333c0 .22.077.433.216.589A.7.7 0 0 0 .74 22h22.523a.7.7 0 0 0 .522-.244.888.888 0 0 0 .216-.589V4.833a.888.888 0 0 0-.216-.589.7.7 0 0 0-.522-.244H22zM7 2H4v2H2V.97c-.016-.518.378-.952.88-.97h5.24c.502.018.896.452.88.97V4H7zM5 13a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2H6a1 1 0 0 0-1 1zm8 0a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h.4a1 1 0 0 0 1-1v-1h.6a1 1 0 0 0 0-2h-.6v-1a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1v1h-1a1 1 0 0 0-1 1z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.car_lamp:
      return (
        <IconTemplate {...props} width={16} height={24}>
          <path
            fill="#fff"
            d="M14.004 16h-12v-1h2a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h2zm-2.984 4h-6v-2h6zM6.004 5a2 2 0 1 1 4 0v6h-4V5zm9 8h-2v-1a1 1 0 0 0-1-1V5a4.001 4.001 0 0 0-3-3.874V1a1 1 0 1 0-2 0v.126c-1.725.444-3 2.01-3 3.874v6a1 1 0 0 0-1 1v1h-2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2v3a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 1-1v-3h2a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.motoSearch:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path
            fill="#fff"
            d="M24 9.084c-3.235 3.363-7.06 10.644-7.06 10.644s-2.396-1.413-4.808-1.464l.69 1.91-2.255.826-.86-2.38c-1.504.433-2.649 1.108-2.649 1.108S3.232 12.444 0 9.084c1.498-1.56 3.109-2.844 4.897-3.775L4 2.827 6.255 2l.857 2.371c1.499-.494 3.118-.76 4.888-.76 4.966 0 8.75 2.088 12 5.473zm-12 6.815c1.956 0 3.874 1.411 3.874 1.411s2.449-5.324 4.926-8.034c-2.51-2.105-5.573-3.247-8.8-3.247-1.395 0-2.76.214-4.063.626l3.361 9.3c.231-.035.466-.056.702-.056zM8.123 17.31s.353-.259.91-.555L5.718 7.582A14.215 14.215 0 0 0 3.2 9.276c2.498 2.732 4.923 8.034 4.923 8.034z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.basket:
      return (
        <IconTemplate {...props} width={22} height={22}>
          <path
            fill={fill}
            d="M17.588 17.6c-1.206 0-2.183.99-2.183 2.2 0 1.21.977 2.2 2.184 2.2 1.206 0 2.194-.99 2.194-2.2 0-1.21-.988-2.2-2.195-2.2zm-10.99 0c-1.21 0-2.189.99-2.189 2.2 0 1.21.979 2.2 2.189 2.2s2.199-.99 2.199-2.2c0-1.21-.99-2.2-2.2-2.2zM5.674 4.4h13.36l-3.035 5.5H8.28zm10.325 7.7c.825 0 1.55-.451 1.924-1.133l3.937-7.139a1.096 1.096 0 0 0-.957-1.628H4.63L3.596 0H0v2.2h2.2l3.958 8.349-1.485 2.684c-.802 1.474.253 3.267 1.925 3.267h13.195v-2.2H6.598l1.21-2.2z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.sales:
      return (
        <IconTemplate {...props} width={24} height={22}>
          <g>
            <path
              fill={fill}
              d="M19.617 12.481l-.605.653.086.854.195 1.959-2.053.432-.907.19-.476.744L14.787 19l-1.923-.773-.864-.342-.854.342L9.223 19l-1.07-1.677-.475-.744-.907-.19-2.053-.432.194-1.969.087-.854-.605-.653L3 11.005l1.394-1.486.605-.653-.097-.864-.195-1.949 2.053-.432.907-.19.476-.744L9.213 3l1.923.773.864.342.854-.342L14.777 3l1.07 1.687.475.744.907.19 2.053.432-.194 1.959-.087.854.605.653L21 10.995zM24 10.99l-2.662-2.923.371-3.866-3.938-.86L15.709 0 12 1.53 8.29 0 6.23 3.342l-3.94.848.372 3.877L0 10.99l2.662 2.922-.371 3.877 3.938.859L8.291 22 12 20.46l3.71 1.53 2.06-3.342 3.94-.86-.372-3.865z"
            />
            <path
              fill={fill}
              d="M16 8.515L9.515 15 8.1 13.586 14.586 7.1zM11 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
            />
          </g>
        </IconTemplate>
      );
    case ICON_NAMES.news:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path
            fill={fill}
            d="M17 10H7V8h10zm-5 4H7v-2h5zm7-11H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10l6-6V5c0-1.1-.9-2-2-2zm0 2v9h-5v5H5V5h14"
          />
        </IconTemplate>
      );
    case ICON_NAMES.favoritesChecked:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path fill={fill} d="M12,1.5,8.9,8.8,1,9.5l6,5.2L5.2,22.5,12,18.4l6.8,4.1L17,14.7l6-5.2-7.9-.7Z" />
        </IconTemplate>
      );
    case ICON_NAMES.favoritesUnchecked:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path
            fill={fill}
            d="M12,6.5l1.1,2.8.6,1.4h1.4l2.9.3-2.2,2-1.1,1,.3,1.4.7,3-2.5-1.6L12,16.1l-1.2.8L8.3,18.5l.7-3L9.3,14,8.2,13,6,11.1l2.9-.3h1.4l.6-1.4L12,6.5m0-5L8.9,8.8,1,9.5l6,5.2L5.2,22.5,12,18.4l6.8,4.1L17,14.7l6-5.2-7.9-.7Z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.favorites:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path
            fill={fill}
            d="M12,6.5l1.1,2.8.6,1.4h1.4l2.9.3-2.2,2-1.1,1,.3,1.4.7,3-2.5-1.6L12,16.1l-1.2.8L8.3,18.5l.7-3L9.3,14,8.2,13,6,11.1l2.9-.3h1.4l.6-1.4L12,6.5m0-5L8.9,8.8,1,9.5l6,5.2L5.2,22.5,12,18.4l6.8,4.1L17,14.7l6-5.2-7.9-.7Z"
          />
        </IconTemplate>
      );

    case ICON_NAMES.manager:
      return (
        <IconTemplate {...props} width={18} height={18}>
          <path
            fill={fill}
            d="M16 14.46c-.88-.06-1.75-.21-2.6-.45l-1.2 1.2c1.2.41 2.48.67 3.8.76zM2.03 2c.09 1.32.35 2.58.75 3.79l1.2-1.21c-.23-.83-.38-1.7-.45-2.58zM18 13.5V17c0 .55-.45 1-1 1C7.61 18 0 10.39 0 1c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1l-2.2 2.21c1.44 2.84 3.76 5.15 6.59 6.59l2.2-2.2c.2-.19.45-.29.71-.29.1 0 .21.02.31.05 1.12.37 2.32.57 3.57.57.55 0 1 .45 1 1zM9 2V0a9 9 0 0 1 9 9h-2c0-3.87-3.13-7-7-7zm0 4V4c2.76 0 5 2.24 5 5h-2c0-1.66-1.34-3-3-3z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.balance:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path
            fill={fill}
            d="M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.44-.82-1.91-2.66-2.23V5h-1.75v1.26c-2.6.56-2.62 2.85-2.62 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 3.02 2.96V19h1.75v-1.24c.52-.09 3.02-.59 3.02-3.22.01-1.39-.6-2.61-3-3.44zM12 21c-4.961 0-9-4.039-9-9s4.039-9 9-9 9 4.039 9 9-4.039 9-9 9zm0-20C5.928 1 1 5.928 1 12s4.928 11 11 11 11-4.928 11-11S18.072 1 12 1z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.order_history:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path
            fill={fill}
            d="M12 7v5.32L16.233 15 17 13.638l-3.506-2.223V7zm.571-5c-5.206 0-9.428 4.254-9.428 9.5H0l4.075 4.106.074.148L8.38 11.5H5.238c0-4.085 3.28-7.389 7.333-7.389 4.055 0 7.334 3.304 7.334 7.389 0 4.085-3.28 7.389-7.334 7.389a7.247 7.247 0 0 1-5.175-2.175l-1.487 1.5A9.346 9.346 0 0 0 12.57 21C17.778 21 22 16.746 22 11.5S17.778 2 12.571 2z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.message:
      return (
        <IconTemplate {...props} width={18} height={22}>
          <path
            fill={fill}
            d="M14 8.714C14 6.116 11.49 4 9 4S4 6.116 4 8.714V16h10zm4 8.195V18H0v-1.09l2.25-2.183V9.273c0-3.36 1.845-6.153 5.063-6.895v-.742C7.313.731 8.066 0 9 0s1.688.73 1.688 1.636v.742c3.228.742 5.062 3.546 5.062 6.895v5.454zM7 20h5c0 1.1-1.125 2-2.5 2S7 21.1 7 20z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.arrows:
      return (
        <IconTemplate {...props} width={8} height={16}>
          <path fill="#0a2352" d="M8 11H0l4 5z" />
          <path fill="#0a2352" d="M8 5H0l4-5z" />
        </IconTemplate>
      );
    case ICON_NAMES.arrows_desc:
      return (
        <IconTemplate {...props} width={8} height={16}>
          <path fill="#1d8eff" d="M8 11H0l4 5z" />
        </IconTemplate>
      );
    case ICON_NAMES.arrows_asc:
      return (
        <IconTemplate {...props} width={8} height={16}>
          <path fill="#1d8eff" d="M8 5H0l4-5z" />
        </IconTemplate>
      );
    case ICON_NAMES.copy:
      return (
        <IconTemplate {...props} width={30} height={30}>
          <path
            fill="#1d8eff"
            d="M22 11H12v12h10zm2 0v12c0 1.1-.9 2-2 2H12c-1.1 0-2-.9-2-2V11c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2zm-6-4H8v14H6V7c0-1.1.9-2 2-2h10z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.paginationArrowLeft:
      return (
        <IconTemplate {...props} width={7.5} height={12}>
          <g transform="translate(-285.000000, -315.000000)">
            <g transform="translate(0.000000, 290.000000)">
              <g transform="translate(260.000000, 0.000000)">
                <path fill="#0A2352" d="M31.1,37L25,31l6.1-6l1.4,1.4L27.8,31l4.7,4.6L31.1,37z" />
              </g>
            </g>
          </g>
        </IconTemplate>
      );
    case ICON_NAMES.paginationArrowRight:
      return (
        <IconTemplate {...props} width={7.5} height={12}>
          <g transform="translate(-285.000000, -315.000000)">
            <g transform="translate(0.000000, 290.000000)">
              <g transform="translate(260.000000, 0.000000)">
                <path fill="#0A2352" d="M25,35.6l4.7-4.6L25,26.4l1.4-1.4l6.1,6l-6.1,6L25,35.6z" />
              </g>
            </g>
          </g>
        </IconTemplate>
      );
    case ICON_NAMES.paginationArrowStart:
      return (
        <IconTemplate {...props} width={9.7} height={12}>
          <g transform="translate(-285.000000, -315.000000)">
            <g transform="translate(0.000000, 290.000000)">
              <g transform="translate(260.000000, 0.000000)">
                <path fill="#0A2352" d="M33.3,37l-6.1-6l6.1-6l1.4,1.4L30,31l4.7,4.6L33.3,37z M27,37h-2V25h2V37z" />
              </g>
            </g>
          </g>
        </IconTemplate>
      );
    case ICON_NAMES.paginationArrowEnd:
      return (
        <IconTemplate {...props} width={9.7} height={12}>
          <g transform="translate(-285.000000, -315.000000)">
            <g transform="translate(0.000000, 290.000000)">
              <g transform="translate(260.000000, 0.000000)">
                <path fill="#0A2352" d="M25,35.6l4.7-4.6L25,26.4l1.4-1.4l6.1,6l-6.1,6L25,35.6z M32.7,25h2v12h-2V25z" />
              </g>
            </g>
          </g>
        </IconTemplate>
      );
    case ICON_NAMES.dotsSquare:
      return (
        <IconTemplate {...props} width={4} height={16}>
          <path
            fill="#fff"
            d="M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm0-6c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM0 2C0 .9.9 0 2 0s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.deleteFromBasket:
      return (
        <IconTemplate {...props} width={10} height={10}>
          <path fill="white" d="M10 8.59L8.59 10 5 6.41 1.41 10 0 8.59 3.59 5 0 1.41 1.41 0 5 3.59 8.59 0 10 1.41 6.41 5 10 8.59z" />
        </IconTemplate>
      );
    case ICON_NAMES.goBack:
      return (
        <IconTemplate {...props} width={16} height={8}>
          <path fill="#0a2352" d="M4 3h12v2H4v3L0 4l4-4z" />
        </IconTemplate>
      );
    case ICON_NAMES.goForward:
      return (
        <IconTemplate {...props} width={16} height={8}>
          <path fill="#0a2352" d="M4 3h12v2H4v3L0 4l4-4z" />
        </IconTemplate>
      );
    case ICON_NAMES.listArrowRight:
      return (
        <IconTemplate {...props} width={12} height={8}>
          <g transform="rotate(180 6 4)">
            <path fill="#0a2352" d="M1.41-.59L6 3.99l4.59-4.58L12 .82l-6 6-6-6z" />
          </g>
        </IconTemplate>
      );
    case ICON_NAMES.filterArrow:
      return (
        <IconTemplate {...props} width={12} height={8}>
          <g transform="rotate(180 6 4)">
            <path fill="#fff" d="M1.41-.59L6 3.99l4.59-4.58L12 .82l-6 6-6-6z" />
          </g>
        </IconTemplate>
      );
    case ICON_NAMES.watched:
      return (
        <IconTemplate {...props} width={22} height={15}>
          <path
            fill="#0a2352"
            d="M15.5 7.5c0 2.5-2.02 4.5-4.5 4.5s-4.5-2-4.5-4.5S8.52 3 11 3s4.5 2 4.5 4.5zM11 5a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5zm0-5C6 0 1.73 3.11 0 7.5 1.73 11.89 6 15 11 15s9.27-3.11 11-7.5C20.27 3.11 16 0 11 0zm0 2a9.77 9.77 0 0 1 8.82 5.5A9.77 9.77 0 0 1 11 13a9.77 9.77 0 0 1-8.82-5.5A9.77 9.77 0 0 1 11 2"
          />
        </IconTemplate>
      );
    case ICON_NAMES.warning:
      return (
        <IconTemplate {...props} width={24} height={22}>
          <defs>
            <clipPath id="5ohya">
              <path fill="#fff" d="M8.57 2.717a4 4 0 0 1 6.86 0l7.935 13.225A4 4 0 0 1 19.935 22H4.065a4 4 0 0 1-3.43-6.058z" />
            </clipPath>
            <clipPath id="5ohyb">
              <path fill="#fff" d="M13 17h-2v-2h2z" />
            </clipPath>
            <clipPath id="5ohyc">
              <path fill="#fff" d="M13 14h-2V8h2z" />
            </clipPath>
          </defs>
          <path
            fill="none"
            stroke="red"
            strokeMiterlimit="20"
            strokeWidth="4"
            d="M8.57 2.717a4 4 0 0 1 6.86 0l7.935 13.225A4 4 0 0 1 19.935 22H4.065a4 4 0 0 1-3.43-6.058z"
            clipPath='url("#5ohya")'
          />
          <path fill="none" stroke="red" strokeMiterlimit="20" strokeWidth="4" d="M13 17v0h-2v0-2 0h2v0z" clipPath='url("#5ohyb")' />
          <path fill="none" stroke="red" strokeMiterlimit="20" strokeWidth="4" d="M13 14v0h-2v0-6 0h2v0z" clipPath='url("#5ohyc")' />
        </IconTemplate>
      );
    case ICON_NAMES.success:
      return (
        <IconTemplate {...props} width={40} height={40}>
          <path
            fill="#27b95b"
            d="M38.8 13.22c.76 2.12 1.2 4.4 1.2 6.78 0 11-9 20-20 20S0 31 0 20 9 0 20 0c4.26 0 8.2 1.34 11.44 3.62L28.56 6.5C26.08 4.92 23.16 4 20 4 11.16 4 4 11.16 4 20s7.16 16 16 16 16-7.16 16-16c0-1.22-.16-2.42-.42-3.56zM40 6.36L17.18 29.2 8.7 20.72l2.82-2.82 5.66 5.66 20-20z"
          />
        </IconTemplate>
      );
    case ICON_NAMES.clip:
      return (
        <IconTemplate {...props} width={11} height={20}>
          <path
            d="M9.5 5V14.5C9.5 16.71 7.71 18.5 5.5 18.5C3.29 18.5 1.5 16.71 1.5 14.5V4C1.5 2.62 2.62 1.5 4 1.5C5.38 1.5 6.5 2.62 6.5 4V14.5C6.5 15.05 6.05 15.5 5.5 15.5C4.95 15.5 4.5 15.05 4.5 14.5V5H3V14.5C3 15.88 4.12 17 5.5 17C6.88 17 8 15.88 8 14.5V4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4V14.5C0 17.54 2.46 20 5.5 20C8.54 20 11 17.54 11 14.5V5H9.5Z"
            fill="#1D8EFF"
          />
        </IconTemplate>
      );
    case ICON_NAMES.loyalty_coins:
      return (
        <IconTemplate {...props} width={24} height={24}>
          <path
            d="M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V9.45715C11.7785 9.82398 11 10.3789 11 11M2 5V17C2 18.1046 4.46243 19 7.5 19C8.82963 19 10.0491 18.8284 11 18.5429V11M11 11C11 12.1046 13.4624 13 16.5 13C19.5376 13 22 12.1046 22 11M11 11C11 9.89543 13.4624 9 16.5 9C19.5376 9 22 9.89543 22 11M11 11V19C11 20.1046 13.4624 21 16.5 21C19.5376 21 22 20.1046 22 19V11M2 9C2 10.1046 4.46243 11 7.5 11C8.82963 11 10.0491 10.8284 11 10.5429M2 13C2 14.1046 4.46243 15 7.5 15C8.82963 15 10.0491 14.8284 11 14.5429M22 15C22 16.1046 19.5376 17 16.5 17C13.4624 17 11 16.1046 11 15"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ fill: 'none' }}
          />
        </IconTemplate>
      );
    case ICON_NAMES.cash:
      return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.5 11C10.8056 11 10.2153 10.7569 9.72917 10.2708C9.24306 9.78472 9 9.19444 9 8.5C9 7.80556 9.24306 7.21528 9.72917 6.72917C10.2153 6.24306 10.8056 6 11.5 6C12.1944 6 12.7847 6.24306 13.2708 6.72917C13.7569 7.21528 14 7.80556 14 8.5C14 9.19444 13.7569 9.78472 13.2708 10.2708C12.7847 10.7569 12.1944 11 11.5 11ZM5.5 13C5.0875 13 4.73438 12.853 4.44062 12.559C4.14687 12.2651 4 11.9117 4 11.4988V5.49417C4 5.08139 4.14687 4.72917 4.44062 4.4375C4.73438 4.14583 5.0875 4 5.5 4H17.5C17.9125 4 18.2656 4.14701 18.5594 4.44104C18.8531 4.73493 19 5.08833 19 5.50125V11.5058C19 11.9186 18.8531 12.2708 18.5594 12.5625C18.2656 12.8542 17.9125 13 17.5 13H5.5ZM7 11.5H16C16 11.0833 16.1469 10.7283 16.4406 10.435C16.7344 10.1418 17.0875 9.99521 17.5 9.99521V7C17.0875 7 16.7344 6.85312 16.4406 6.55937C16.1469 6.26562 16 5.9125 16 5.5H7C7 5.91667 6.85313 6.27167 6.55938 6.565C6.26563 6.85819 5.9125 7.00479 5.5 7.00479V10C5.9125 10 6.26563 10.1469 6.55938 10.4406C6.85313 10.7344 7 11.0875 7 11.5ZM16.5 16H2.5C2.0875 16 1.73438 15.8531 1.44063 15.5594C1.14688 15.2656 1 14.9125 1 14.5V6H2.5V14.5H16.5V16Z"
            fill={fill}
          />
        </svg>
      );
    case ICON_NAMES.cashless:
      return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 5.5V14.5C18 14.9028 17.8531 15.2535 17.5594 15.5521C17.2656 15.8507 16.9125 16 16.5 16H3.5C3.09722 16 2.74653 15.8507 2.44792 15.5521C2.14931 15.2535 2 14.9028 2 14.5V5.5C2 5.09722 2.14931 4.74653 2.44792 4.44792C2.74653 4.14931 3.09722 4 3.5 4H16.5C16.9125 4 17.2656 4.14931 17.5594 4.44792C17.8531 4.74653 18 5.09722 18 5.5ZM3.5 7H16.5V5.5H3.5V7ZM3.5 10V14.5H16.5V10H3.5Z"
            fill={fill}
          />
        </svg>
      );
    default:
      return null;
  }
};

export { Icon as default, ICON_NAMES };
